import { z } from 'zod';

/**
 * Per-user preferences, stored on the user's row and synced across devices.
 * Every key has a default so a stored object from before a key existed still
 * parses; unknown keys are dropped on read.
 */
export const UserPreferences = z.object({
  /** After applying other people's changes, keep the touched rows marked until cleared. */
  highlightAppliedChanges: z.boolean().default(true),
  /**
   * Live collaboration is available to this account: trips that have it
   * turned on (Manage trip) stream other people's edits and presence instead
   * of holding them behind Apply. Off hides the feature entirely.
   */
  liveCollaboration: z.boolean().default(false),
});
export type UserPreferences = z.infer<typeof UserPreferences>;

export const USER_PREFERENCE_DEFAULTS: UserPreferences = UserPreferences.parse({});

/** PATCH /api/me/preferences — any subset of keys; the response is the full object. */
export const UpdateUserPreferencesInput = UserPreferences.partial().strict();
export type UpdateUserPreferencesInput = z.infer<typeof UpdateUserPreferencesInput>;

/** Stored JSON → typed preferences. Anything unparseable falls back to the defaults. */
export function parseUserPreferences(stored: unknown): UserPreferences {
  const result = UserPreferences.safeParse(stored ?? {});
  return result.success ? result.data : USER_PREFERENCE_DEFAULTS;
}
